<template>
  <menu-group class="outgoing-relations__endcard">
    <input-texteditor
      v-if="ctx.endElement != null"
      class="mb-2"
      :label="$t('labels.description')"
      :value="description"
      @update:value="description = $event"
    />
    <template v-if="ctx.endElement != null">
      <button class="button mt-2" type="button" @click="createFlow()">
        {{ $t("actions.createFlow") }}
      </button>
    </template>
    <template v-else>
      <p class="message mt-0 mb-2">
        {{ $t("messages.chooseElement") }}
      </p>
    </template>
  </menu-group>
</template>

<script setup lang="ts">
/**
 * End card of relation creation menu.
 * Outgoing relations are created here.
 */
import { computed } from "vue";
import { useFlowBuilder } from "./flowBuilder.js";

import MenuGroup from "@core/ui/MenuGroup.vue";
import InputTexteditor from "@core/input/TextEditor.vue";

import { useFlowBranchStore } from "../flow/flowBranches.store";

const ctx = useFlowBuilder();

const flowBranchStore = useFlowBranchStore();

const relationDraftId = computed(() => {
  const { baseElement, endElement } = ctx;
  if (endElement == null || baseElement == null) {
    return null;
  }
  return `${baseElement.type}.${baseElement.id}-${endElement.type}.${endElement.id}`;
});

const relationDrafts = computed(() => {
  return {} as Record<string, { description: string }>;
  // return relationStore.relationDrafts;
});

const relationDraft = computed(() => {
  if (relationDraftId.value == null) return null;
  return relationDrafts.value?.[relationDraftId.value];
});

const description = computed({
  get() {
    return relationDraft.value?.description ?? "";
  },
  set(value: string) {
    if (!relationDraft.value) {
      if (relationDraftId.value == null) {
        console.warn("no relation draft id.");
        return;
      }
      relationDrafts.value[relationDraftId.value] = {
        description: value
      };
    } else {
      relationDraft.value.description = value;
    }
  }
});

async function createFlow() {
  if (ctx.baseElement == null) {
    console.warn("can't create relation without base element.");
    return;
  }
  if (ctx.endElement == null) {
    console.warn("can't create relation without end element.");
    return;
  }

  const { flow } = await flowBranchStore.createFlowBetween(ctx.baseElement, ctx.endElement, {
    description: description.value
  });
  return flow;
}
</script>

<style lang="scss">
.outgoing-relations__endcard {
  padding: 2rem 1rem;
  z-index: 1;
  position: relative;
  background-color: var(--color-background-deep);
  width: 100%;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.4);
  flex-shrink: 0;
}
</style>
